import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("> ")
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "features__container" }
const _hoisted_5 = { class: "testimonials__container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","color":"#fff","margin-top":"30px"} }, [
  /*#__PURE__*/_createTextVNode(" Challenge by "),
  /*#__PURE__*/_createElementVNode("a", {
    style: {"color":"var(--Cyan)"},
    href: "https://www.frontendmentor.io?ref=challenge",
    target: "_blank"
  }, "Frontend Mentor"),
  /*#__PURE__*/_createTextVNode(". Coded by "),
  /*#__PURE__*/_createElementVNode("a", {
    style: {"color":"var(--Cyan)"},
    target: "_blank",
    href: "https://github.com/Chainsmoker"
  }, "Chainsmoker By Calvin"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Presentation = _resolveComponent("Presentation")!
  const _component_FeaturesItem = _resolveComponent("FeaturesItem")!
  const _component_TestimonialsCards = _resolveComponent("TestimonialsCards")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Navbar),
      _createVNode(_component_Presentation, {
        direction: "column",
        image: "images/illustration-intro.png",
        title: "All your files in one secure location, accessible anywhere.",
        desc: "Fylo stores all your most important files in one secure location. Access them wherever you need, share and collaborate with friends family, and co-workers."
      }),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FeaturesItem, {
          image: "images/icon-access-anywhere.svg",
          title: "Access your files, anywhere",
          desc: "The ability to use a smartphone, tablet, or computer to access your account means your files follow you everywhere."
        }),
        _createVNode(_component_FeaturesItem, {
          image: "images/icon-security.svg",
          title: "Security you can trust",
          desc: "2-factor authentication and user-controlled encryption are just a couple of the security features we allow to help secure your files."
        }),
        _createVNode(_component_FeaturesItem, {
          image: "images/icon-collaboration.svg",
          title: "Real-time collaboration",
          desc: "Securely share files and folders with friends, family and colleagues for live collaboration. No email attachments required."
        }),
        _createVNode(_component_FeaturesItem, {
          image: "images/icon-any-file.svg",
          title: "Store any type of file",
          desc: "Whether you're sharing holidays photos or work documents, Fylo has you covered allowing for all file types to be securely stored and shared."
        })
      ]),
      _createVNode(_component_Presentation, {
        direction: "row",
        image: "images/illustration-stay-productive.png",
        title: "Stay productive, wherever you are",
        desc: "Never let location be an issue when accessing your files. Fylo has you covered for all of your file storage needs."
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TestimonialsCards, {
          userPic: "images/profile-1.jpg",
          userName: "Satish Patel",
          userPosition: "Founder & CEO, Huddle",
          content: "Fylo has improved our team productivity by an order of magnitude. Since making the switch our team has become a well-oiled collaboration machine."
        }),
        _createVNode(_component_TestimonialsCards, {
          userPic: "images/profile-2.jpg",
          userName: "Bruce McKenzie",
          userPosition: "Founder & CEO, Huddle",
          content: "Fylo has improved our team productivity by an order of magnitude. Since making the switch our team has become a well-oiled collaboration machine."
        }),
        _createVNode(_component_TestimonialsCards, {
          userPic: "images/profile-3.jpg",
          userName: "Iva Boyd",
          userPosition: "Founder & CEO, Huddle",
          content: "Fylo has improved our team productivity by an order of magnitude. Since making the switch our team has become a well-oiled collaboration machine."
        })
      ]),
      _createElementVNode("footer", null, [
        _createVNode(_component_Footer),
        _hoisted_6
      ])
    ])
  ], 64))
}